<ion-content class="chooser ion-padding">
  <div class="chooser__close">
    <ion-button fill="clear" size="small" (click)="dismiss()" aria-label="Close">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <h2 class="chooser__title">{{ copy.Title }}</h2>

  @if (loading()) {
    <div class="chooser__loading" role="status" aria-live="polite">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  } @else {
    <!-- Audience segment — shown only when the org group has published tiers, so
         a single-group chooser stays a plain list (ADR-0123). -->
    @if (showSegment()) {
      <ion-segment
        class="chooser__segment"
        [value]="activeGroup()"
        (ionChange)="onGroupChange($any($event).detail.value)"
      >
        <ion-segment-button value="individual">
          <ion-icon name="person-outline" aria-hidden="true"></ion-icon>
          <ion-label>{{ copy.GroupIndividual }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="org">
          <ion-icon name="business-outline" aria-hidden="true"></ion-icon>
          <ion-label>{{ copy.GroupOrganisation }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    }

    @if (activeGroup() === 'individual') {
      @if (individualPlans().length) {
        <ion-radio-group
          [value]="selectedPlanId()"
          (ionChange)="onSelectPlan($any($event).detail.value)"
        >
          @for (p of individualPlans(); track p.id) {
            <div class="chooser__plan">
              <ion-radio [value]="p.id" labelPlacement="end" justify="start">
                <span class="chooser__plan-label">
                  <span class="chooser__plan-name">{{ p.name }}</span>
                  <span class="chooser__plan-terms">
                    <span class="chooser__plan-price">{{ planPrice(p) }}</span>
                    @if (frequencyLabel(p.billingInterval, p.billingIntervalCount)) {
                      <span class="chooser__plan-frequency">
                        {{ frequencyLabel(p.billingInterval, p.billingIntervalCount) }}
                      </span>
                    }
                  </span>
                </span>
              </ion-radio>
            </div>
          }
        </ion-radio-group>
      } @else {
        <p class="chooser__empty">{{ copy.NoPlans }}</p>
      }
    } @else {
      @if (orgTiers().length) {
        <ion-radio-group
          [value]="selectedTierId()"
          (ionChange)="onSelectTier($any($event).detail.value)"
        >
          @for (t of orgTiers(); track t.id) {
            <div class="chooser__plan">
              <ion-radio [value]="t.id" labelPlacement="end" justify="start">
                <span class="chooser__plan-label">
                  <span class="chooser__plan-name">{{ t.name }}</span>
                  <span class="chooser__plan-terms">
                    <span class="chooser__plan-price">{{ tierPrice(t) }}</span>
                    @if (frequencyLabel(t.billingInterval, t.billingIntervalCount)) {
                      <span class="chooser__plan-frequency">
                        {{ frequencyLabel(t.billingInterval, t.billingIntervalCount) }}
                      </span>
                    }
                  </span>
                  <span class="chooser__plan-meta">
                    <span>{{ seatsLabel(t) }}</span>
                    @if (tierPerSeat(t)) {
                      <span class="chooser__plan-perseat">{{ tierPerSeat(t) }}</span>
                    }
                  </span>
                </span>
              </ion-radio>
            </div>
          }
        </ion-radio-group>
      } @else {
        <p class="chooser__empty">{{ copy.NoPlans }}</p>
      }
    }

    <div class="chooser__actions">
      <ion-button
        expand="block"
        (click)="continue()"
        [disabled]="!canContinue()"
      >
        {{ copy.Continue }}
      </ion-button>
    </div>
  }
</ion-content>
